module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Preface"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e67",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Preface ")])])])])]), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of goji and mulberry."
    }
  }, [_c('a', {
    attrs: {
      "id": "d0e67",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of goji and mulberry.",
      "src": "images/Preface.jpg"
    }
  })])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e67",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Growing much of what we eat has been one of the greatest joys of living at Hortulus Farm,\n        and my passion for searching out unusual and interesting varieties of our common food plants\n        remains unabated; so it is with great pleasure that I offer up to you eighty-five of the\n        most winning edible plants on the planet. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e67",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The world truly is our horticultural oyster, with exciting new cultivars and even entirely\n        unfamiliar species, like the goji and the honeyberry, coming to us from every corner of the\n        globe. As well, in this tome, I urge you towards the cultivation of some of our lesser known\n        edible plants, like anise, chervil, the persimmon, and the lingonberry, any of which will\n        not only provide you with new culinary avenues to explore but plenty of visual delight in\n        your garden. And then there are the fascinating histories, antique employments, myths and\n        lore, however occasionally misguided, surrounding even our most familiar fruits, herbs, and\n        vegetables. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e67",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Have I personally grown every plant, shrub, and tree in this book? No, and for fairly\n        obvious cultural and climatic reasons, most particularly some of the finicky fruit trees\n        that require a daunting regime of spraying, pruning, and fruit-thinning. That said, I have\n        been vigilant in both research and visitation of neighboring farmers and orchardists, and\n        the varietal information and cultural advice I impart to you here you may rely on. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e67",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("My sincere hope is that you will find these plant portraits as enjoyable to browse as they\n        are informative and that you will be inspired to culture some of these wonderful edible\n        plants in your own garden. And if you’re ever in our neighborhood, please do come see what\n        we’re growing on the farm! ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e67",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Jack Staub Hortulus Farm ")]), _c('a', {
    staticClass: "ulink",
    attrs: {
      "href": "http://www.hortulusfarm.com",
      "target": "_blank"
    }
  }, [_vm._v("www.hortulusfarm.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee45c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 66
// module chunks = 0